import React, { PropsWithChildren } from "react";

type ButtonPropsType = PropsWithChildren & {
  className?: string;
};
function Button({ children, className = "" }: ButtonPropsType) {
  return (
    <button
      className={`shadow bg-blue  rounded-md lg:rounded-xl text-white font-bold leading-3 lg:leading-6 text-[10px] lg:text-xl px-7 lg:px-8 py-3 lg:py-4 ${className}`}
    >
      {children}
    </button>
  );
}

export default Button;
